'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z' });

var UnfoldLess = function UnfoldLess(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

UnfoldLess = (0, _pure2.default)(UnfoldLess);
UnfoldLess.muiName = 'SvgIcon';

exports.default = UnfoldLess;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/UnfoldLess.js
// module id = 2968
// module chunks = 0